import { createAction } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const retryCatalogItemsRequest = createAction("".concat(stateName, "/retryCatalogItemsRequest"));
export const getCatalogItemsSuccess = createAction("".concat(stateName, "/getCatalogItemsSuccess"), (payload, meta) => ({
  payload,
  meta
}));